/**
 *   Created by FANGlh on 2018/11/12 20:13.
 */

import React, {Component} from 'react';
import './ScoreInquiry.css';
import moment from 'moment';

export default class ScoreData extends Component {
    componentWillMount() {
        document.title = '成绩查询'
    }

    constructor(props) {
        super();
    }

    render() {

        return (
            <div style={{width: '100%'}}>
                <div className="top_Time"><span className="top_time_span">{this.props.itemdata.scoreBasic.scoreDate}</span></div>
                <div className="score_data_sty">
                    <div className="title_sty">{this.props.itemdata.title}</div>
                    <div className="gray-line" style={{height: '1px'}}></div>
                    <div className="left_sty1">
                        <div style={{width: "50%", padding: 10}}>
                            <div style={{fontSize: 12, color: "#999999", padding: 10}}>考试时间:<span style={{
                                color: "#333333",
                                marginLeft: 5
                            }}>{moment(this.props.itemdata.scoreBasic.scoreDate).format('YYYY-MM-DD')}</span></div>
                            <div className="left_sty">姓名: <span
                                className="right_sty">{this.props.itemdata.scoreBasic.stuName} </span></div>
                            <div className="left_sty">科目: <span
                                className="right_sty">{this.props.itemdata.scoreBasic.scoreName}</span></div>
                            <div className="left_sty">得分: <span
                                className="right_sty">{this.props.itemdata.scoreBasic.scoreRank==null?this.props.itemdata.scoreBasic.scoreNum:this.props.itemdata.scoreBasic.scoreRank}</span></div>
                            <div className="left_sty">总分: <span
                                className="right_sty">{this.props.itemdata.scoreBasic.scoreTotal}</span></div>
                        </div>
                        <div style={{height: 100, width: 1, background: "#F2F2F2", marginTop: 60}}></div>
                        <div style={{width: "50%", padding: 10}}>
                            <div style={{fontSize: 12, color: "#999999", padding: 10}}>考试范围:<span style={{
                                color: "#333333",
                                marginLeft: 5
                            }}>{this.props.itemdata.scoreBasic.scoreScope}</span></div>
                            <div className="left_sty">班级排名: <span
                                className="right_sty">{this.props.itemdata.scoreBasic.classRank}</span></div>
                            <div className="left_sty">年级排名: <span
                                className="right_sty">{this.props.itemdata.scoreBasic.gradeRank}</span></div>
                            <div className="left_sty">班级平均分: <span
                                className="right_sty">{this.props.itemdata.scoreBasic.classAverage}</span></div>
                            <div className="left_sty">年级平均分: <span
                                className="right_sty">{this.props.itemdata.scoreBasic.gradeAverage}</span></div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}